// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__+ojsd","footerFlexContainer":"Footer_footerFlexContainer__HoJNt","footerIcons":"Footer_footerIcons__nx7Mr"};